import { Box, Card, CardContent, CardHeader, Grid, makeStyles, Theme, Typography } from "@material-ui/core"
import { COLOR_GRAY } from "../../../constants"
import { useTranslations } from "./useTranslations"
import { ProjectsDashboardViewModel } from "../../api/projects-dashboard"
import UpcomingProjectsStatusBasedPieChart from "./UpcomingProjectsStatusBasedPiechart"
import OpenProjectsScheduleGraph from "./OpenProjectsScheduleGraph"
import CompletionStatistics from "./CompletionStatistics"
import ManagersBasedPieChart from "./ManagersBasedPieChart"

const UpcomingProjectsOverview = ({ projectsDashboard }: UpcomingProjectsOverviewProps) => {
  const classes = useStyles()
  const translations = useTranslations({
    projectCount: projectsDashboard.totalUpcomingProjects,
    managerCount: projectsDashboard.totalNumberOfManagers,
  })

  const pieChartTitle = translations.pieChartCardHeader
  const openProjectsBarTitle = translations.scheduleLabel
  const managersPieChartTitle = translations.managersPieChartCardHeader

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <Card variant="outlined" className={classes.card}>
            <CardHeader title={<Typography variant="body1">{pieChartTitle}</Typography>} />
            <CardContent className={classes.pieChart}>
              <UpcomingProjectsStatusBasedPieChart projectsDashboard={projectsDashboard} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card variant="outlined" className={classes.card}>
            <CardContent>
              <Box className={classes.barChartSection}>
                <Typography variant="body1">{openProjectsBarTitle}</Typography>
                <OpenProjectsScheduleGraph projectsDashboard={projectsDashboard} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <Card variant="outlined" className={classes.card}>
            <CardHeader title={<Typography variant="body1">{managersPieChartTitle}</Typography>} />
            <CardContent className={classes.pieChart}>
              <ManagersBasedPieChart
                totalNumberOfProjects={projectsDashboard.totalUpcomingProjects}
                groupedProjects={projectsDashboard.groupedProjectsBasedOnManagers}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card variant="outlined" className={classes.card}>
            <CardContent>
              <Box className={classes.barChartSection}>
                <Typography variant="body1">{translations.manualCompletionBarTitle}</Typography>
                <CompletionStatistics
                  totalProjects={projectsDashboard.totalUpcomingProjects}
                  groupedProjects={projectsDashboard.manualCompletionStatistics}
                />
              </Box>
              <Box className={classes.barChartSection}>
                <Typography variant="body1">{translations.taskBasedCompletionBarTitle}</Typography>
                <CompletionStatistics
                  totalProjects={projectsDashboard.totalUpcomingProjects}
                  groupedProjects={projectsDashboard.tasksBasedCompletionStatistics}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    height: "100%",
  },
  cardHeader: {
    color: COLOR_GRAY,
    fontSize: "1rem",
  },
  pieChart: {
    padding: theme.spacing(0, 2),
  },
  barChartSection: {
    padding: theme.spacing(0, 0, 4, 0),
  },
}))

export default UpcomingProjectsOverview
type UpcomingProjectsOverviewProps = {
  projectsDashboard: ProjectsDashboardViewModel
}
